"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class DocumentModel extends _1.BaseModel {
    static fromContentDocument(contentDocument) {
        return new DocumentModel({
            _id: contentDocument.LatestPublishedVersionId,
            createdAt: contentDocument.CreatedDate,
            deleteId: contentDocument.Id,
            name: (contentDocument.FileExtension) ? `${contentDocument.Title}.${contentDocument.FileExtension}` : contentDocument.Title,
            ownerId: contentDocument.OwnerId,
            type: contentDocument.FileType && contentDocument.FileType.toLowerCase()
        });
    }
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            name: 'Name',
            ownerId: 'OwnerId',
            createdAt: 'CreatedDate'
        };
    }
}
exports.DocumentModel = DocumentModel;
//# sourceMappingURL=document.model.js.map